import { memo } from 'react';
import cls from 'classnames';

import styles from './MetricBar.module.css';

interface MetricBarProps {
  svg: string;
  className?: string;
  ratio: number;
  'aria-label'?: string;
}

function MetricBar({ svg, className, ratio, 'aria-label': ariaLabel = 'Metric scale chart' }: MetricBarProps) {
  return <img alt="" aria-label={ariaLabel} className={cls(styles.metricBar, className)} src={svg} style={{ aspectRatio: `${ratio}` }} />;
}

export default memo(MetricBar);
